import { render } from "./receiptModal.vue?vue&type=template&id=2b5d7e68&scoped=true"
import script from "./receiptModal.vue?vue&type=script&lang=js"
export * from "./receiptModal.vue?vue&type=script&lang=js"

import "./receiptModal.vue?vue&type=style&index=0&id=2b5d7e68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5d7e68"]])

export default __exports__